export default __webpack_public_path__ + "static/1-258fb5d5939aea18e7af16ebfb793e0f.png";